<template>
  <div class="ai-ask-page">
    <div class="container_wrap">
      <div class="ai-ask-container">
        <div class="page-header">
          <h1>RAG法律智能问答</h1>
          <p class="subtitle">输入您的问题，获取智能答案</p>
        </div>

        <!-- 输入区域 -->
        <div class="input-section">
          <el-input
            type="textarea"
            :rows="6"
            placeholder="请输入您的问题..."
            v-model="question"
            :disabled="loading"
            class="question-input"
          >
          </el-input>
          
          <div class="button-group">
            <el-button 
              type="primary" 
              @click="askQuestion"
              :loading="loading"
              :disabled="!question.trim()"
              size="large"
            >
              {{ loading ? '提问中...' : '提问' }}
            </el-button>
            <el-button 
              @click="clearInput"
              :disabled="loading"
              size="large"
            >
              清空
            </el-button>
          </div>
        </div>

        <!-- 问答列表 -->
        <div class="qa-list" v-if="qaList.length > 0">
          <h2 class="list-title">问答记录</h2>
          
          <div class="qa-item" v-for="(item, index) in qaList" :key="index">
            <!-- 问题卡片 -->
            <el-card class="question-card" shadow="never">
              <div class="card-header">
                <i class="el-icon-question"></i>
                <span class="label">问题</span>
                <span class="time">{{ item.time }}</span>
              </div>
              <div class="card-content">
                {{ item.question }}
              </div>
            </el-card>

            <!-- 答案卡片 -->
            <el-card class="answer-card" shadow="hover">
              <div class="card-header">
                <i class="el-icon-chat-dot-round"></i>
                <span class="label">答案</span>
                <el-tag 
                  size="small" 
                  :type="getMethodType(item.method)"
                  v-if="item.method"
                >
                  {{ getMethodText(item.method) }}
                </el-tag>
              </div>
              <div class="card-content answer-content">
                {{ item.answer }}
              </div>
              <div class="source-section" v-if="item.source">
                <div class="source-label">
                  <i class="el-icon-document"></i>
                  来源说明：
                </div>
                <div class="source-content">
                  {{ item.source }}
                </div>
              </div>
            </el-card>
          </div>
        </div>

        <!-- 空状态 -->
        <div class="empty-state" v-else>
          <i class="el-icon-chat-line-square"></i>
          <p>暂无问答记录，请输入问题开始提问</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: "AiAsk",
  data() {
    return {
      question: '',
      loading: false,
      qaList: [] // 问答列表
    };
  },
  mounted() {
    window.scrollTo(0, 0);
    // 从localStorage加载历史记录
    this.loadHistory();
  },
  methods: {
    // 提问
    async askQuestion() {
      if (!this.question.trim()) {
        this.$message.warning('请输入问题');
        return;
      }

      this.loading = true;
      
      try {
        const response = await axios.post(
          'http://47.118.24.52:8081/ask',
          {
            question: this.question.trim()
          },
          {
            headers: {
              'Content-Type': 'application/json'
            }
          }
        );

        // 创建问答记录
        const qaItem = {
          question: this.question.trim(),
          answer: response.data.answer || '暂无答案',
          method: response.data.method || '',
          source: response.data.source || '',
          time: this.formatTime(new Date())
        };

        // 添加到列表顶部
        this.qaList.unshift(qaItem);
        
        // 保存到localStorage
        this.saveHistory();

        // 清空输入框
        this.question = '';

        // 显示成功提示
        this.$message.success('提问成功');

      } catch (error) {
        console.error('提问失败:', error);
        const errorMessage = (error.response && error.response.data && error.response.data.message) || '提问失败，请稍后重试';
        this.$message.error(errorMessage);
      } finally {
        this.loading = false;
      }
    },

    // 清空输入
    clearInput() {
      this.question = '';
    },

    // 获取方法类型对应的标签样式
    getMethodType(method) {
      const typeMap = {
        'direct_extraction': 'success',
        'inference': 'warning',
        'unknown': 'info'
      };
      return typeMap[method] || 'info';
    },

    // 获取方法文本
    getMethodText(method) {
      const textMap = {
        'direct_extraction': '直接提取',
        'inference': '推理分析',
        'unknown': '未知方法'
      };
      return textMap[method] || method;
    },

    // 格式化时间
    formatTime(date) {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      const hours = String(date.getHours()).padStart(2, '0');
      const minutes = String(date.getMinutes()).padStart(2, '0');
      const seconds = String(date.getSeconds()).padStart(2, '0');
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    },

    // 保存历史记录
    saveHistory() {
      try {
        // 只保存最近20条记录
        const historyToSave = this.qaList.slice(0, 20);
        localStorage.setItem('ai_qa_history', JSON.stringify(historyToSave));
      } catch (error) {
        console.error('保存历史记录失败:', error);
      }
    },

    // 加载历史记录
    loadHistory() {
      try {
        const history = localStorage.getItem('ai_qa_history');
        if (history) {
          this.qaList = JSON.parse(history);
        }
      } catch (error) {
        console.error('加载历史记录失败:', error);
        this.qaList = [];
      }
    }
  }
};
</script>

<style scoped lang="scss">
.ai-ask-page {
  min-height: 100vh;
  background: #f5f7fa;
  padding: 40px 0;
}

.ai-ask-container {
  max-width: 1000px;
  margin: 0 auto;
}

.page-header {
  text-align: center;
  margin-bottom: 40px;
  
  h1 {
    font-size: 36px;
    color: #303133;
    margin-bottom: 12px;
    font-weight: 600;
  }
  
  .subtitle {
    font-size: 16px;
    color: #909399;
  }
}

.input-section {
  background: #fff;
  padding: 30px;
  border-radius: 12px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
  margin-bottom: 40px;
  
  .question-input {
    margin-bottom: 20px;
    
    ::v-deep textarea {
      font-size: 15px;
      line-height: 1.6;
      resize: vertical;
    }
  }
  
  .button-group {
    display: flex;
    gap: 12px;
    
    .el-button {
      padding: 12px 40px;
      font-size: 16px;
    }
  }
}

.qa-list {
  .list-title {
    font-size: 24px;
    color: #303133;
    margin-bottom: 24px;
    font-weight: 600;
  }
}

.qa-item {
  margin-bottom: 30px;
  
  .question-card {
    margin-bottom: 12px;
    border-left: 4px solid #409eff;
    
    ::v-deep .el-card__body {
      padding: 20px;
    }
  }
  
  .answer-card {
    border-left: 4px solid #67c23a;
    
    ::v-deep .el-card__body {
      padding: 20px;
    }
  }
  
  .card-header {
    display: flex;
    align-items: center;
    margin-bottom: 12px;
    gap: 8px;
    
    i {
      font-size: 18px;
    }
    
    .label {
      font-size: 16px;
      font-weight: 600;
      color: #303133;
    }
    
    .time {
      margin-left: auto;
      font-size: 13px;
      color: #909399;
    }
  }
  
  .card-content {
    font-size: 15px;
    line-height: 1.8;
    color: #606266;
    white-space: pre-wrap;
    word-break: break-word;
  }
  
  .answer-content {
    color: #303133;
    font-weight: 500;
  }
  
  .source-section {
    margin-top: 16px;
    padding-top: 16px;
    border-top: 1px dashed #e4e7ed;
    
    .source-label {
      display: flex;
      align-items: center;
      gap: 6px;
      font-size: 14px;
      color: #909399;
      margin-bottom: 8px;
      font-weight: 600;
      
      i {
        font-size: 16px;
      }
    }
    
    .source-content {
      font-size: 14px;
      line-height: 1.6;
      color: #606266;
      padding-left: 22px;
      white-space: pre-wrap;
      word-break: break-word;
    }
  }
}

.empty-state {
  text-align: center;
  padding: 80px 20px;
  background: #fff;
  border-radius: 12px;
  
  i {
    font-size: 80px;
    color: #dcdfe6;
    margin-bottom: 16px;
  }
  
  p {
    font-size: 16px;
    color: #909399;
  }
}

// 响应式设计
@media (max-width: 768px) {
  .ai-ask-page {
    padding: 20px;
  }
  
  .page-header {
    h1 {
      font-size: 28px;
    }
  }
  
  .input-section {
    padding: 20px;
    
    .button-group {
      flex-direction: column;
      
      .el-button {
        width: 100%;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// AiAsk.vue?da809d66